import { Avatar, Table } from '@heroui/react';
import type { Selection } from 'react-aria-components';
import type { UserWithMemberships } from '../../../api/users';
import { getUserDisplayName, getUserInitials } from '../utils/user-labels';

interface UserListTableProps {
  users: UserWithMemberships[];
  selectedUserId: string | null;
  onSelectUser: (userId: string) => void;
}

export function UserListTable({ users, selectedUserId, onSelectUser }: UserListTableProps) {
  const selectedKeys = selectedUserId ? new Set<string>([selectedUserId]) : new Set<string>();

  const handleSelectionChange = (keys: Selection) => {
    if (keys === 'all') return;
    const next = Array.from(keys)[0];
    if (next) onSelectUser(String(next));
  };

  return (
    <Table aria-label="Lista de usuários" className="min-w-0">
      <Table.ScrollContainer className="max-h-[calc(100vh-16rem)]">
        <Table.Content
          selectionMode="single"
          disallowEmptySelection
          selectedKeys={selectedKeys}
          onSelectionChange={handleSelectionChange}
        >
          <Table.Header>
            <Table.Column isRowHeader>Usuário</Table.Column>
            <Table.Column>E-mail</Table.Column>
            <Table.Column className="w-20 text-right">Assoc.</Table.Column>
          </Table.Header>
          <Table.Body items={users}>
            {(user) => {
              const displayName = getUserDisplayName(user);

              return (
                <Table.Row id={user.id} className="cursor-pointer">
                  <Table.Cell>
                    <div className="flex min-w-0 items-center gap-2">
                      <Avatar size="sm" color="accent">
                        {user.photoUrl ? (
                          <Avatar.Image src={user.photoUrl} alt={displayName} />
                        ) : null}
                        <Avatar.Fallback>{getUserInitials(user)}</Avatar.Fallback>
                      </Avatar>
                      <span className="truncate font-medium text-foreground">{displayName}</span>
                    </div>
                  </Table.Cell>
                  <Table.Cell className="max-w-[10rem] truncate text-muted">{user.email}</Table.Cell>
                  <Table.Cell className="text-right text-muted">{user.memberships.length}</Table.Cell>
                </Table.Row>
              );
            }}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  );
}
